var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { getIsAuth } from 'src/redux/auth/authSelectors';
import { getI18n } from 'src/redux/core/coreSelectors';
import { Loader } from 'src/ui/components/Loader/Loader';
import { windowExist } from 'src/shared/constants';
//import { Loader } from 'src/ui/components/Loader/Loader'
// Has it's HOC (High Order Component) props only include props in parent (here is props inject by App)
export var withAuthenticatedPage = function (Component) { return function (props) {
    var isAuth = useSelector(getIsAuth);
    return isAuth ? (_jsx(Component, __assign({}, props))) : (_jsx("div", __assign({ style: { display: 'flex', height: '100vh', width: '100%', marginTop: 60 } }, { children: _jsx("h1", __assign({ style: { marginTop: 60 } }, { children: "Not auth" })) })));
}; };
export var withI18nExist = function (Component) { return function (props) {
    var i18n = useSelector(getI18n);
    return i18n ? (_jsx(Component, __assign({}, props))) : (_jsx("div", __assign({ style: { display: 'flex', height: '100vh', width: '100%', marginTop: 60 } }, { children: _jsx(Loader, {}) })));
}; };
export var changeTabTitle = function (title) {
    if (windowExist) {
        document.title = title;
    }
};
export var changeFavicon = function (path) {
    var faviconElement = document.getElementById('favicon');
    var isSameFavicon = faviconElement === null || faviconElement === void 0 ? void 0 : faviconElement.href.includes(path);
    if (!!faviconElement && !isSameFavicon) {
        document.head.removeChild(faviconElement);
        var newFavicon = document.createElement('link');
        newFavicon.rel = 'icon';
        newFavicon.id = 'favicon';
        newFavicon.href = window.env.BASE_PATH + path;
        document.head.appendChild(newFavicon);
    }
};
